import { useTranslation } from "react-i18next";
import PrimaryBtn from "../../components/buttons/PrimaryBtn";
import BackBtn from "../../components/buttons/BackBtn";

export default function PortfolioFrat() {
  const { t } = useTranslation();

  return (
    <div className="md:px-20 isolate px-6 lg:px-8 flex flex-1 items-center justify-center max-w-5xl">
      <div className="w-full flex flex-col justify-center items-start py-10 md:py-10">

        <BackBtn></BackBtn>

        <div className="text-left mb-16 w-full">
          <h1 className="mb-20 tx1 text-center">
            {t("portfolio.projects.frat.name")}
          </h1>
          <p className="mt-10 tm2">
            {t("portfolio.projects.frat.goal")}
          </p>
          <p className="mt-5 tm2">
            {t("portfolio.projects.frat.description")}
          </p>
          <p className="mt-5 tm2">
            {t("portfolio.projects.frat.demoNote")}
          </p>

          <div className="flex mt-10 w-full">
            <PrimaryBtn
              to="https://frat.com.pl/"
              targetBlank
              fullWidth={false}
              className="max-w-xs mx-auto"
            >
              {t("portfolio.demoBtn")}
            </PrimaryBtn>
          </div>

          <div className="flex flex-col items-center justify-center mt-10 mx-auto gap-4">
            <a
              href="https://frat.com.pl/"
              className="card-image"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img
                src="/assets/projects/frat.jpg"
                alt="Frat"
                className="rounded-lg shadow-md"
              />
            </a>
          </div>
        </div>

        <div className="w-full">


          <h3 className="tx3 mb-2 md:mb-8">
            {t("portfolio.projects.frat.generalTitle")}
          </h3>
          <ul className="list-primary-dot ml-6 tm1">
            <li>{t("portfolio.projects.frat.general1")}</li>
            <li>{t("portfolio.projects.frat.general2")}</li>
            <li>{t("portfolio.projects.frat.general3")}</li>
            <li>{t("portfolio.projects.frat.general4")}</li>
            <li>{t("portfolio.projects.frat.general5")}</li>
          </ul>

          <div className="card-image-mobile-view mt-10 flex gap-1">
            <img
              src="/assets/projects/frat-1.jpg"
              alt="Frat Features"
              className="rounded-lg shadow-md"
            />
            <img
              src="/assets/projects/frat-2.jpg"
              alt="Frat Features"
              className="rounded-lg shadow-md"
            />
            <img
              src="/assets/projects/frat-3.jpg"
              alt="Frat Features"
              className="rounded-lg shadow-md"
            />
          </div>

          <h2 className="tx2 text-left mt-10 md:mt-20 ">
            {t("portfolio.projects.frat.featuresTitle")}
          </h2>
          <h3 className="tx3 mb-2 md:mb-8 mt-10 ">
            {t("portfolio.projects.frat.forArtistsTitle")}
          </h3>
          <ul className="list-primary-dot ml-6 tm1">
            <li>{t("portfolio.projects.frat.artist1")}</li>
            <li>{t("portfolio.projects.frat.artist2")}</li>
            <li>{t("portfolio.projects.frat.artist3")}</li>
            <li>{t("portfolio.projects.frat.artist4")}</li>
          </ul>

          <div className="card-image-mobile-view mt-10 flex gap-1">
            <img
              src="/assets/projects/frat-4.jpg"
              alt="For Artists"
              className="rounded-lg shadow-md"
            />
            <img
              src="/assets/projects/frat-5.jpg"
              alt="For Artists"
              className="rounded-lg shadow-md"
            />
            <img
              src="/assets/projects/frat-6.jpg"
              alt="For Artists"
              className="rounded-lg shadow-md"
            />
          </div>

          <h3 className="tx3 mb-2 md:mb-8 mt-20">
            {t("portfolio.projects.frat.forManagersTitle")}
          </h3>
          <ul className="list-primary-dot ml-6 tm1">
            <li>{t("portfolio.projects.frat.manager1")}</li>
            <li>{t("portfolio.projects.frat.manager2")}</li>
            <li>{t("portfolio.projects.frat.manager3")}</li>
          </ul>

          {/* <div className="card-image-mobile-view mt-10 flex gap-1">
            <img
              src="/assets/projects/frat-7.jpg"
              alt="For Managers"
              className="rounded-lg shadow-md"
            />
            <img
              src="/assets/projects/frat-8.jpg"
              alt="For Managers"
              className="rounded-lg shadow-md"
            />
            <img
              src="/assets/projects/frat-9.jpg"
              alt="For Managers"
              className="rounded-lg shadow-md"
            />
          </div> */}

          <h3 className="tx3 mb-2 md:mb-8 mt-20">
            {t("portfolio.projects.frat.forPromotersTitle")}
          </h3>
          <ul className="list-primary-dot ml-6 tm1 mb-20">
            <li>{t("portfolio.projects.frat.promoter1")}</li>
            <li>{t("portfolio.projects.frat.promoter2")}</li>
            <li>{t("portfolio.projects.frat.promoter3")}</li>
          </ul>

        </div>
      </div>
    </div>
  );
}
